// extracted by mini-css-extract-plugin
export default {"link":"components_link__EdvbB"};